import {Model} from "./Model";

export class Plan extends Model {
    sku;
    name;
    details;
    days;
    price;
    full_price;
    price_breakdown;
}